module.exports = require('./helpers/bundle-url').getBundleURL('gbl1F') + "logo.c51670a8.svg";